import { CollectionsPage, CollectionDetailsPage } from "collections/pages";
import { COLLECTIONS_ENABLED } from "collections/constants";
import EntityCollectionActions, {
  DashboardCollectionsModal,
  SearchManageCollectionsModal,
  SearchEntityCollectionActions,
  ShareCollectionsModal
} from "collections/components/EntityCollectionActions";
import AddCollectionFormGroup from "collections/components/AddCollectionFormGroup";
import { getCollectionsCustomColumnRenderer } from "collections/components/EntityCollectionCell";
import { expandedCollectionSections } from "collections/components/EntityCollectionExpandedSection";
import UserCollections from "collections/components/UserCollections";
import CollectionGranteeList from "collections/components/CollectionGranteeList";
import { prefixUrl } from "routing/Routes";
import EntityCollectionTableCell from "./components/EntityCollectionTableCell";
import useCollectionActionCondition from "./hooks/useCollectionActionCondition";
import useCollectionViewCondition from "./hooks/useCollectionViewCondition";
import SharedEntityCollectionCell from "./components/SharedEntitiesCollectionCell";
import CollectionsRoutes from "./Routes";
const collectionsBindings = {
  routes: [
    { path: CollectionsRoutes.unqualified.LIST, component: CollectionsPage },
    { path: CollectionsRoutes.unqualified.show(":collectionId"), component: CollectionDetailsPage }
  ],
  "components.collection": {
    AddCollectionFormGroup,
    UserCollections,
    CollectionGranteeList
  },
  "views.components.dashboardActions": [
    {
      component: EntityCollectionActions,
      key: "manage-collections",
      modal: DashboardCollectionsModal,
      useCondition: () => useCollectionActionCondition()
    }
  ],
  "components.shared.entityActions": [
    {
      component: EntityCollectionActions,
      key: "manage-collections",
      modal: ShareCollectionsModal,
      useCondition: () => useCollectionActionCondition()
    }
  ],
  "views.components.searchActions": [
    {
      component: SearchEntityCollectionActions,
      key: "manage-collections",
      modals: [
        {
          key: "searchManageCollectionModal",
          component: SearchManageCollectionsModal
        }
      ],
      useCondition: () => useCollectionActionCondition()
    }
  ],
  "components.shared.entityTableElements": [
    {
      attributeName: "collections",
      attributes: [{ id: "collections", title: "Collections" }],
      // @ts-expect-error TODO: Fix typing here
      getColumnRenderer: getCollectionsCustomColumnRenderer,
      expandedSection: expandedCollectionSections,
      tableCellComponent: EntityCollectionTableCell,
      useCondition: () => useCollectionViewCondition()
    }
  ],
  "components.permission.shared.entity.tableElements": [
    {
      attributeName: "collections",
      attributes: [{ id: "collections", title: "Collections" }],
      tableCellComponent: SharedEntityCollectionCell,
      useCondition: () => useCollectionViewCondition()
    }
  ],
  entityTypeRoute: [
    {
      type: "collection",
      route: (id) => prefixUrl(`/collections/${id}`)
    },
    {
      type: "collection_entities",
      route: (id) => prefixUrl(`/collections/${id}`)
    }
  ]
};
export default COLLECTIONS_ENABLED ? collectionsBindings : {};
